import Model from "./base/model";
import Client from "../http/client";
import id from "element-ui/src/locale/lang/id";

class Order extends Model {
  resourceName() {
    return "orders";
  }

  fields() {
    return {
      collection_date_time: "",
      delivery_date_time: "",
      scheduling_date_time: "",
      boarding_value: "",
      is_traceable: "",
      reverse: "",
      is_mirrored: "",
      modal: "",
      distance:"",
      type_freight: "",
      vehicle_options:"",
      vehicle_plate: "",
      trailer_plate: "",
      origin_airport: "",
      destiny_airport: "",
      last_active_status_id: "",
      order_observation:"",
      collection_observation:"",
      collection_address_data:"",
      delivery_address_data:"",
      additional_services:{jsonApi: "hasMany", type:"order_additional_services"},
      original_order_id:"",
      driver_name:"",
      driver_cpf:"",
      transporter_name:"",
      transporter_cnpj:"",
      justification_id: "",
      justification_message: "",
      transporter: {jsonApi: "hasOne", type: "transporters"},
      risk_manager: {jsonApi: "hasOne", type: "risk_managers"},
      customer: {jsonApi: "hasOne", type: "customers"},
      possible_transporters: {jsonApi: "hasMany", type: "transporters"},
      shipper: {jsonApi: "hasOne", type: "shippers"},
      delivery_address: {jsonApi: "hasMany", type: "order_delivery_addresses"},
      collection_address: {jsonApi: "hasOne", type: "order_collection_addresses"},
      status: {jsonApi: "hasMany", type: "status"},
      simulation_orders: {jsonApi: "hasOne", type: "simulation_orders"},
      nf_files: {jsonApi: "hasMany", type: "nf_files"},
      cte_files: {jsonApi: "hasMany", type: "cte_files"},
      canhoto_files: {jsonApi: "hasMany", type: "canhoto_files"},
      risk_manager_order: {jsonApi: "hasOne", type: "risk_manager_orders"},
      driver:{jsonApi: "hasOne", type: "drivers"},
      helper:{jsonApi: "hasOne", type: "helpers"},
      project_name: "",
      cost_center: "",
      purchase_order: {jsonApi: "hasMany", type: "purchase_orders"},
      geolocation_drivers: {jsonApi: "hasMany", type: "geolocation_drivers"},
      audits_order: {jsonApi: "hasMany", type: "audits_order"},
      audits_order_additional_services: {jsonApi: "hasMany", type: "audits_order_additional_services"},
      vehicle_type_name: {jsonApi: "hasOne", type: "vehicle_types"},
      order_delivery_refuse_data:"",
      airline_id:"",
      alert:"",
      external_id: "",
      icms: "",
      road_map_id: "",
      road_map: {jsonApi: "hasOne", type: "road_maps"},
      notfis_files: {jsonApi: "hasMany", type: "notfis_files"},
      simulation_integra_orders: {jsonApi: "hasOne", type: "simulation_integra_orders"},
      supplier: {jsonApi: "hasOne", type: "suppliers"},
      romaneio_files: {jsonApi: "hasMany", type: "romaneio_files"},
      route_table_order: {jsonApi: "hasMany", type: "route_table_order"},
      table_model: "",
      shipment_numbers: "",
      users_follow: {jsonApi: "hasMany", type: "user_follow_order"},
      follow: "",
      oficio_files: {jsonApi: "hasMany", type: "oficio_files"},
      shipper_order_code: "",
      vehicle_last_position: {jsonApi: "hasOne", type: "geolocation_drivers"},
      is_tracking_via_app: "",
      quotation_transporter_id: "",
      road_map_requests_files: "",
      road_map_requests_files_type: "",
      integration_status: "",
      order_invoices: {jsonApi: "hasMany", type: "order_invoices"},
      order_integration_tasks: {jsonApi: "hasMany", type: "order_integration_tasks"},
      romaneio_path: "",
      created_at: "",
    };
  }

  async createMy(data) {
    return this.request(
      this.resourceName() + "/me",
      "POST",
      {},
      data
    );
  }

  async enrich(id, data) {
    return this.request(
      this.resourceName() + "/enrich/" + id,
      "POST",
      {},
      data
    );
  }

  async acceptRequest(id, data) {
    return this.request(
      this.resourceName() + "/accept/" + id,
      "POST",
      {},
      data
    );
  }

  async refuseRequest(id, data) {
    return this.request(
      this.resourceName() + "/refuse/" + id,
      "POST",
      {},
      data
    );
  }

  async getTransporterOrdersProposals(filters) {
    return this.request(
      this.resourceName() + "/proposals",
      "GET",
      filters
    );
  }

  async getAuditedOrders(params=null) {
    return this.request(
      this.resourceName() + "/audited",
      "GET",
      params
    );
  }

  /**
   * Atualiza o status do pedido.
   *
   * A acao ("set" adiciona, "remove" remove) vai no meta do documento, e nao
   * como atributo, porque nao faz parte do recurso "orders" — declara-la em
   * fields() a colocaria no contrato JSON:API do pedido.
   */
  async updateOrderStatus(id, statusId, action = "set") {

    let payload = Object.assign(
      {},
      {id: statusId, type: 'status'},
    );

    return this.request(
      this.resourceName() + "/update_status/" + id,
      "POST",
      {},
      {id: id, status: {payload}},
      {action: action}
    );
  }

  async fractionateOrder(id, data) {
    return this.request(
      this.resourceName() + "/fractionate/" + id,
      "POST",
      {},
      data
    );
  }
  async fractionateAirOrder(id, data) {
    return this.request(
      this.resourceName() + "/fractionate_air/" + id,
      "POST",
      {},
      data
    );
  }
  async generateRoadOrder(id, data) {
    return this.request(
      this.resourceName() + "/generate_road/" + id,
      "POST",
      {},
      data
    );
  }
  async createSubLTL(data) {
    return this.request(
      this.resourceName() + "/sub_ltl",
      "POST",
      {},
      data
    );
  }
  // async createMy(payload, params = {}, meta = {}, options = {}) {
  //   return this.middleware(
  //     () => Client.create(this.resourceName(), payload, params, meta),
  //     options
  //   );
  // }
  async cancel(id, data) {
    return this.request(
      this.resourceName() + "/cancel/" + id,
      "POST",
      {},
      data
    );
  }
  async refuseDelivery(id, data) {
    return this.request(
      this.resourceName() + "/refuse_delivery/" + id,
      "POST",
      {},
      data
    );
  }
  async setAlert(id) {
    return this.request(
      this.resourceName() + "/alert/" + id,
      "POST",
      {},
      {}
    );
  }

  async updateIcms(id, data) {
    return this.request(
      this.resourceName() + "/icms/" + id,
      "PATCH",
      {},
      data
    );
  }

  async replicateOrder(id, data) {
    return this.request(
      this.resourceName() + `/replicate/${id}`,
      "POST",
      {},
      data
    );
  }

  async follow(id) {
    return this.request(
      `${this.resourceName()}/follow/${id}`,
      "POST",
      {},
      {}
    );
  }

  async unfollow(id) {
    return this.request(
      `${this.resourceName()}/unfollow/${id}`,
      "POST",
      {},
      {}
    );
  }
  async storeWithSimulationQuoteTransportersHash(hash, data){
    return this.request(
      `${this.resourceName()}/store_with_simulation_quote_transporters_hash/${hash}`,
      "POST",
      {},
      data
    );
  }

  async findByOrderIdOrShipperOrderCode(order_id_or_shipper_order_code, options){
    return this.request(
      `${this.resourceName()}/order_id_or_shipper_order_code/${order_id_or_shipper_order_code}`,
      "GET",
      options,
      {}
    );
  }
}

export default new Order();
